import React from "react"
import PropTypes from "prop-types"
import { KeyValue } from "../keyValue/KeyValue.jsx"
import * as css from "./KeyValueList.module.css"

const KeyValueList = ({ list, title }) => {
  if (!list) {
    return null
  }

  const specs = list
    .filter(s => {
      // when there is no value, we don't display
      if (!s || !s.value) {
        return false
      }

      return true
    })
    .map(s => ({
      ...s,
      value: s.value instanceof Function ? s.value() : s.value,
    }))
    .filter(s => {
      // when there is a special condition, we try to evaluate it
      if (typeof s.when !== "undefined") {
        if (s.when instanceof Function && !s.when()) {
          return false
        } else if (!s.when) {
          return false
        }
      }

      return true
    })

  if (specs.length === 0) {
    return null
  }

  return (
    <>
      {title && <h3 className={css.title}>{title}</h3>}
      <div className={css.keyvalues}>
        {specs.map((spec, k) => (
          <KeyValue {...spec} key={k} />
        ))}
      </div>
    </>
  )
}

KeyValueList.propTypes = {
  list: PropTypes.array,
  title: PropTypes.string,
}

export { KeyValueList }
